import styled from "styled-components";
import { Colors } from "../config/Constants";
import { getInitials } from "../helper";

const UserAvatar = ({
  imgSrc,
  width = "3.25rem",
  height = "3.25rem",
  bgdColor,
  onClick,
  userName,
}) => {
  return imgSrc ? (
    <Avatar width={width} height={height} onClick={onClick}>
      <img src={imgSrc} alt="profile_logo" />
    </Avatar>
  ) : (
    <ProfileLogo
      width={width}
      height={height}
      onClick={onClick}
      bgdColor={bgdColor}
    >
      {getInitials(userName)}
    </ProfileLogo>
  );
};

const Avatar = styled.div`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  cursor: ${(props) => (props.onClick ? "pointer" : "default")};
  object-fit: contain;
  background: ${Colors.white};
  border-radius: 50%;
  > img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: contain;
  }
`;

const ProfileLogo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  border-radius: 50%;
  background-color: ${(props) =>
    props.bgdColor ? props.bgdColor : Colors.brightGray};
  color: black;
  font-size: 20px;
  font-weight: bold;
  text-transform: uppercase;
  cursor: ${(props) => (props.onClick ? "pointer" : "default")};
`;

export default UserAvatar;
